import React from 'react';
import { List, Datagrid, TextField, DateField, FunctionField, ReferenceInput, AutocompleteInput, TopToolbar, CreateButton, Button, useTranslate } from 'react-admin';
import { Link } from 'react-router-dom';
import MenuBookIcon from '@mui/icons-material/MenuBook';

import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';

import useReviewGrid from './useReviewGrid';
import { kindLabel, statusLabel } from './ReviewForm';

const userOptionText = choice => choice?.fullname ? choice.fullname : '';

const ReviewListActions = ({ isManager }) => {
    const translate = useTranslate();
    return (
        <TopToolbar>
            <Button component={Link} to="/review-grid" label={translate('Review grid')}><MenuBookIcon /></Button>
            {isManager && <CreateButton />}
        </TopToolbar>
    );
};

// Replaces react-admin's empty state, which offers a Create button nobody but the manager may use.
const NoSharedReview = () => {
    const translate = useTranslate();
    return (
        <Card sx={{ marginTop: '16px', width: '100%' }}>
            <CardContent>
                <Typography>{translate('No review has been shared with you yet.')}</Typography>
            </CardContent>
        </Card>
    );
};

const ReviewList = (props) => {
    const translate = useTranslate();
    const grid = useReviewGrid();

    const filters = [];
    if (grid?.is_manager) {
        filters.push(
            <ReferenceInput key="user_id" source="user_id" reference="users" filter={{ active: true, is_staff: true }} alwaysOn>
                <AutocompleteInput label={translate('Person')} optionText={userOptionText} />
            </ReferenceInput>
        );
    }

    return (
        <List {...props} empty={grid?.is_manager ? undefined : <NoSharedReview />} filters={filters} actions={<ReviewListActions isManager={grid?.is_manager} />} sort={{ field: 'updated_at', order: 'DESC' }}>
            <Datagrid rowClick="show" bulkActionButtons={false}>
                <TextField source="user.fullname" label={translate('Person')} sortable={false} />
                <FunctionField source="kind" label={translate('Type')} render={record => kindLabel(translate, record.kind)} />
                <TextField source="period_label" label={translate('Period')} sortable={false} />
                <FunctionField source="status" label={translate('Status')} render={record => statusLabel(translate, record.status)} />
                <DateField source="updated_at" label={translate('Updated')} />
            </Datagrid>
        </List>
    );
};

export default ReviewList;
